import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// core
import { API, getURL } from "../../core/api";
import { defaultImage } from "../../core/data";
import { getSiteName } from "../../core/utils";

// components
import { Header } from "../../components/Header";
import { SellerProducts } from "../../components/Products";
import { Image, Tabs } from "antd";
import { Note } from "../../components/Note";

const { TabPane } = Tabs;

export const Product = () => {
  const params = useParams();
  const [sites, setSites] = useState([]);
  const [product, setProduct] = useState([]);

  const getSites = () => {
    API.get
      .sites(true)
      .then((response) => {
        if (response.success) {
          setSites(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getProduct = () => {
    API.get
      .product(params.id)
      .then((response) => {
        if (response.success) {
          setProduct(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getSites();
    getProduct();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header title={`کالای شماره ${params.id}`} activeItem="products" />
      <div className="product-page">
        <Tabs defaultActiveKey="1" size="small">
          <TabPane tab="مشخصات" key="1" className="px-20 py-15">
            <div className="product-data flex-row flex-wrap">
              <div className="ml-20">
                <Image
                  className="product-image-medium"
                  src={getURL(product?.image)}
                  fallback={defaultImage}
                  alt="image"
                />
              </div>
              <div className="sm:w-100">
                <p className="font-size-main-1">{product?.name}</p>
                <p>برند: {product?.brand?.name}</p>
                <p>دسته: {product?.category?.name}</p>
                <p>واحد شمارش: {product?.unit?.name}</p>
              </div>
            </div>
          </TabPane>
          {sites?.map((site) => (
            <TabPane
              className="px-20 py-15"
              tab={`فروشگاه ${getSiteName(site.name)}`}
              key={`2${site.id}`}>
              <SellerProducts site={site} unit={product?.unit?.name} />
            </TabPane>
          ))}
        </Tabs>
      </div>
    </>
  );
};
